import React, { useState } from 'react'
import {
    Grid,
    Typography,
    Button,
    Tabs,
    Tab,
    TextField,
    Fade,
} from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import axios from 'axios'

// styles
import useStyles from './styles'
import logo from './compkit.png'

function ResetPassword(props) {

    var classes = useStyles()
    var [passwordValue, setPasswordValue] = useState('')
    var [confirmPasswordValue, setConfirmPasswordValue] = useState('')

    var [error, setError] = useState('')

    const handlePasswordInput = (target) => {
        if(target.id === 'password'){
            setPasswordValue(target.value)
        }else{
            setConfirmPasswordValue(target.value)
        }
    }

    const resetPassword = () => {
        if(passwordValue !== confirmPasswordValue){
            setError('Password and ConfirmPassword does not match')
        }else{
            let token = getTokenFromQueryParams()
            let params = {
                newPassword: passwordValue,
                validationToken: token,
            }
            axios.post('/api/resetpassword', params).then(res => {
				if(res.data.status === true) {
					props.history.push('/login')
				} else {
					setError('Sorry, we are unable to reset password')
				}
            }).catch(err => {
				setError('Sorry, we are unable to reset password')
                console.log(err)
            })
        }
    }

    const getTokenFromQueryParams = () => {
        let queryParam = props.location.search
        let startIndex = queryParam.indexOf('=')
        let token = queryParam.slice(startIndex + 1)
        return token
    }

    return (
        <Grid container className={classes.container}>
            <div className={classes.formContainer}>
            <div className={classes.logotypeContainer}>
					<img src={logo} alt="logo" className={classes.logotypeImage} />
				</div>
                <div className={classes.form}>
                    <Tabs
                        value={0}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab label="Reset Password" classes={{ root: classes.tab }} />
                    </Tabs>
                    <>
						{error ?
							<Fade in={error}>
								<Typography
									color="secondary"
									className={classes.errorMessage}
								>
									{error}
								</Typography>
							</Fade>
							:
							null
						}
                        <TextField
                            id="password"
                            InputProps={{
                                classes: {
                                    underline: classes.textFieldUnderline,
                                    input: classes.textField,
                                },
                            }}
                            value={passwordValue}
                            onChange={e => handlePasswordInput(e.target)}
                            margin="normal"
                            placeholder="Password"
                            type="password"
                            fullWidth
                        />

                        <TextField
                            id="confirmpassword"
                            InputProps={{
                                classes: {
                                    underline: classes.textFieldUnderline,
                                    input: classes.textField,
                                },
                            }}
                            value={confirmPasswordValue}
                            onChange={e => handlePasswordInput(e.target)}
                            margin="normal"
                            placeholder="Confirm Password"
                            type="password"
                            fullWidth
                        />

                        <div className={classes.formButtons}>
                            <Button
                                onClick={(e) => {
									e.preventDefault()
									resetPassword()
								}}
                                variant="contained"
                                color="primary"
                                size="large"
                            >
                                Reset Password
                            </Button>
                        </div>
                    </>
                </div>
                <Typography color="primary" className={classes.copyright}>
                    © 2019 CompKit, LLC. All rights reserved.
				</Typography>
            </div>
        </Grid>
    )
}

export default withRouter(ResetPassword)
